import { css } from "styled-components";
import { FC, PropsWithChildren, ReactNode } from "react";
import AntTooltip from "antd/es/tooltip";
import { useBottomNavigator } from "utils/hooks/misc";
import { TooltipPropsWithTitle as AntTooltipProps } from "antd/es/tooltip";
import BottomDrawer from "common/Drawers/BottomDrawer";

export const tooltipStyles = css`
  .ant-tooltip-inner {
    border-radius: 4px;
  }
  ${(p) =>
    p.theme.isDarkMode &&
    `
    .ant-tooltip-inner, .ant-tooltip-arrow:before {
      background-color: ${p.theme.colors.cardBgColor} !important;
    }
    .ant-tooltip-inner-content {
      color: #FFF;
    }
  `}
`;

interface TooltipProps extends AntTooltipProps {
  showMobileBottomDrawer?: boolean;
  mobileTitle?: string;
  children?: JSX.Element;
}

const Tooltip: FC<PropsWithChildren<TooltipProps>> = ({
  showMobileBottomDrawer,
  mobileTitle,
  children,
  ...props
}) => {
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  if (isBottomNavigator && showMobileBottomDrawer) {
    return (
      <BottomDrawer
        title={mobileTitle}
        content={props.title as ReactNode}
        triggerElement={children}
      />
    );
  }

  return (
    <AntTooltip trigger={isBottomNavigator ? [] : ["hover"]} {...props}>
      {children}
    </AntTooltip>
  );
};

export default Tooltip;
